var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
var SvgCloseIcon = function (props) { return (_jsx("svg", __assign({ width: 15, height: 15, viewBox: "0 0 15 15", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: _jsx("path", { d: "m3.853 12.581 1.106 1.107L11.147 7.5 4.959 1.312 3.853 2.42 8.934 7.5l-5.08 5.081Z", fill: "#fff" }) }))); };
var Memo = memo(SvgCloseIcon);
export default Memo;
//# sourceMappingURL=CloseIcon.js.map